import { ReactElement } from 'react';
import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';

export default function QuickCheckIcon(props: SvgIconProps): ReactElement {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6,16.5c0,0.2,0,0.3,0.1,0.5H1c-0.6,0-1-0.5-1-1s0.4-1,1-1h5V16.5 M3,7h3.1C6,7.2,6,7.3,6,7.5V9H3C2.5,9,2,8.5,2,8
        S2.5,7,3,7 M1,12c0-0.6,0.5-1,1-1h4v2H2C1.5,13,1,12.5,1,12z M8.4,5.5H11l1.7-1.7h5.2l1.7,1.7h2.6c1,0,1.7,0.8,1.7,1.7v10.3
        c0,1-0.8,1.7-1.7,1.7H8.4c-1,0-1.7-0.8-1.7-1.7V7.2C6.7,6.2,7.5,5.5,8.4,5.5 M15.3,8.1C13,8.1,11,10,11,12.4s1.9,4.3,4.3,4.3
        s4.3-1.9,4.3-4.3S17.7,8.1,15.3,8.1 M15.9,12.5l2.3,1.3l-0.6,1l-2.9-1.7v-4h1.2V12.5z"
      />
    </SvgIcon>
  );
}
